import React, { Children } from "react";
import "./button.scss";
export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  variant: "primary" | "secondary" | "text";
  [key: string]: any;
}

export function Button({
  children,
  onClick,
  isDisabled,
  variant,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`mvf-button mvf-button__${variant}`}
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
}
